import { xhrRequest } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['availableHoursCell', 'availableHours', 'formContainer', 'form', 'formErrorContainer', 'paidHoursInput'];

  connect() {
    this.shouldLoadContent && this.loadData();
  }

  openEditForm(event) {
    event && event.preventDefault();
    if (!this.hasFormContainerTarget) {
      App.Helpers.appendContent(this.availableHoursCellTarget, this.form);
      this.paidHoursInputTarget.focus();
      this.paidHoursInputTarget.select();
    }
  }

  submitEditForm(event) {
    event && event.preventDefault();
    xhrRequest(this.editURL, 'post', { user_availability: { paid_hours: this.paidHoursInputTarget.value } }).then(({ data }) => {
      this.closeEditForm();
      this.availableHours = data.paid_minutes;
      this.dataURL && this.loadData();
    }).catch(({ response }) => {
      this.closeEditForm();
      App.Helpers.appendContent(this.availableHoursCellTarget, this.form);
      this.formErrorContainerTarget.innerHTML = this.formError(response.data.error);
      this.paidHoursInputTarget.value = response.data.submitted_value;
    });
  }

  closeEditForm(event) {
    event && event.preventDefault();
    this.hasFormContainerTarget && this.formContainerTarget.remove();
  }

  //
  // INTERNAL USE
  //

  loadData() {
    if (this.dataURL) {
      [...this.element.querySelectorAll('.cell-to-load')].forEach(el => el.innerHTML = App.spinner());
      const url = App.Helpers.addParamsToURL(this.dataURL, { available_minutes: this.availableMinutes });
      xhrRequest(url, 'get').then(({ data }) => {
        App.Helpers.replaceElement(this.element, data);
      });
    }
  }

  formError(message) {
    return `
      <div class="error-notification-box alert alert-danger">
        ${message}
      </div>
    `;
  }

  //
  // GETTERS AND SETTERS
  //

  get shouldLoadContent() {
    return ['1', true, 'true'].indexOf(this.data.get('load')) > -1;
  }

  get dataURL() {
    return this.data.get('data-url');
  }

  get editURL() {
    return this.data.get('edit-url');
  }

  get availableHours() {
    return this.hasAvailableHoursTarget && this.availableHoursTarget.innerText;
  }

  set availableHours(minutes) {
    this.hasAvailableHoursTarget && (this.availableHoursTarget.innerText = App.Helpers.minutesToHoursDecimalString(minutes));
  }

  get availableMinutes() {
    return App.Helpers.parseHourStringForMinutes(this.availableHours);
  }

  get date() {
    return this.data.get('date');
  }

  get dateString() {
    return moment(this.date).format('LL');
  }

  get form() {
    return `
      <div class="availabilities--popup-form" data-${this.identifier}-target="formContainer">
        <h3>${this.dateString}</h3>
        <form data-${this.identifier}-target="form" data-action="${this.identifier}#submitEditForm">
          <div data-${this.identifier}-target="formErrorContainer"></div>

          <div class="form-group">
            <label class="control-label">Paid Hours</label>
            <input type="text" value="${this.availableHours}" data-${this.identifier}-target="paidHoursInput" class="form-control">
          </div>

          <div class="form-actions">
            <input type="submit" name="commit" value="Submit" class="btn btn-primary" data-disable-with="Submit">
            <a class="btn btn-default" data-action="${this.identifier}#closeEditForm">Cancel</a>
          </div>
        </form>
      </div>
    `;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/my-numbers/availabilities-row-controller.js